import {
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import MDBadgeDot from "components/MDBadgeDot";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { generateColorFromString } from "utils/GenerateColorFromString/GenerateColorFromString";
import Loader from "utils/Loader";

const createModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: "550px",
  overflowX: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  "& .MuiFormHelperText-root": { color: "#d32f2f" },
  borderRadius: "0.5rem",
  outline: "none",
};

function DailyGoalModal({ open, handleClose, kpiEntries, loading, handleSave }) {
  const [kpiData, setKpiData] = useState(kpiEntries);
  const handleInputChange = (id, value) => {
    setKpiData((prevData) =>
      prevData.map((kpi) => (kpi.id === id ? { ...kpi, dailyGoal: value } : kpi))
    );
  };

  const handleSaveClick = () => {
    const saveObj = kpiData.map((kpi) => ({
      kpiActionId: kpi.kpiActionId,
      dailyGoal: parseInt(kpi.dailyGoal || 0, 10),
    }));
    handleSave(saveObj);
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <MDBox sx={createModalStyle}>
        <MDTypography
          sx={{ marginBottom: "1rem", p: 1 }}
          id="modal-modal-title"
          variant="h5"
          component="h2"
        >
          Manage Daily Goals
        </MDTypography>
        <TableContainer
          component={Paper}
          sx={{
            maxHeight: "100%",
            userSelect: "none",
            overflowY: "auto",
            position: "relative",
            boxShadow: "none",
            borderRadius: 0,
          }}
        >
          <Loader loading={loading} />
          <Table aria-label="simple table">
            <TableHead sx={{ display: "table-header-group" }}>
              <TableRow>
                <TableCell
                  width="80%"
                  sx={{
                    padding: "0.75rem .6rem",
                  }}
                >
                  KPI
                </TableCell>
                <TableCell
                  align="center"
                  width="20%"
                  sx={{
                    padding: "0.4rem .5rem",
                  }}
                >
                  Daily Goal
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {kpiData?.map((kpi) => (
                <TableRow key={kpi.id}>
                  <TableCell
                    sx={{
                      padding: "0.4rem .6rem",
                      margin: "0",
                      width: "100%",
                      display: "flex",
                      minHeight: "50px",
                      alignItems: "center",
                    }}
                  >
                    <MDBadgeDot
                      size="lg"
                      sx={{
                        ml: 1,
                        p: 0,
                        i: {
                          background: generateColorFromString(kpi?.KpiActivity?.name),
                        },
                      }}
                    />
                    {kpi?.KpiActivity?.name}
                  </TableCell>
                  <TableCell sx={{ padding: "0.4rem .3rem", width: "20%" }} align="center">
                    <TextField
                      type="number"
                      value={kpi.dailyGoal}
                      onChange={(e) => handleInputChange(kpi.id, e.target.value)}
                      InputProps={{
                        // inputProps: { style: { textAlign: "center" } },
                        inputProps: { style: { padding: "0.5rem" } },
                      }}
                      fullWidth
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <MDBox sx={{ display: "flex", justifyContent: "end", mt: 2 }}>
          <MDButton color="gray80" onClick={handleClose} sx={{ mr: 1 }}>
            Cancel
          </MDButton>
          <MDButton color="primaryRed" onClick={handleSaveClick}>
            Save
          </MDButton>
        </MDBox>
      </MDBox>
    </Modal>
  );
}

export default DailyGoalModal;
